import { TabClickProps } from '@/components/atom/Tab';
import { LINE_TAB_COLOR } from '@/components/atom/Tab/LineTab';
import BottomSheet from '@/components/molecules/BottomSheet';
import { BottomSheetTabsListItemProps } from '@/components/molecules/BottomSheet/BottomSheetTabs/BottomSheetTabsList';
import { QnaCategoryGroup, QnaCategoryType } from '@/types/qna';

interface CategoryBottomSheetProps {
  isVisible: boolean;
  categoryGroup?: QnaCategoryGroup;
  selectedTab: QnaCategoryType;
  onClickCategoriesBottomSheetTab: (
    tab: TabClickProps<QnaCategoryType>,
  ) => void;
  toggleBottomSheet: (value: boolean) => void;
  onClickCategoryItem: (item: BottomSheetTabsListItemProps) => void;
  getSelectedTabItemList: () => BottomSheetTabsListItemProps[];
}
const CategoryBottomSheet = ({
  isVisible,
  categoryGroup,
  selectedTab,
  onClickCategoriesBottomSheetTab,
  toggleBottomSheet,
  onClickCategoryItem,
  getSelectedTabItemList,
}: CategoryBottomSheetProps) => {
  if (!categoryGroup) return <></>;
  return (
    <BottomSheet
      index={10}
      isOpened={isVisible}
      onClickOverlay={() => toggleBottomSheet(false)}
    >
      <BottomSheet.Tabs
        tabs={categoryGroup.tabs}
        selectedTab={selectedTab}
        activeColor={LINE_TAB_COLOR.BLACK}
        inActiveColor={LINE_TAB_COLOR.GREY}
        onClickTab={(tab) =>
          onClickCategoriesBottomSheetTab({
            ...tab,
            value: tab.value as QnaCategoryType,
          })
        }
      >
        <BottomSheet.Tabs.List
          items={getSelectedTabItemList()}
          onClickItem={onClickCategoryItem}
        />
      </BottomSheet.Tabs>
    </BottomSheet>
  );
};

export default CategoryBottomSheet;
